import React from "react";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";

import dataOutcomes from "../../data/outcomes.json";
import FormattedDate from "../FormattedDate";
import ImpactItem from "../impact/ImpactItem";
import cleanCompanyName from "../../utilities/cleanCompanyName";
import Permalink from "../Permalink";
import { useDiscussion } from "./DiscussionContext";

function tryToFindOutcomesRelatedToEntity(entity) {
  const outcomes = [];
  const filtered = dataOutcomes.filter((outcome, index) => {
    if ( outcome.entities ) {
      outcome.entities.forEach(outcomeEntity => {
        if ( outcomeEntity.slug === entity.slug || outcomeEntity.slug === entity.old_slug ) {
          outcomes.push(outcome);
        }
      });
    }
  });
  return outcomes;
}

function combineCorrespondenceAndOutcomesByDate(entity) {
  const combined = [];
  const correspondence = entity.correspondence;
  const outcomes = tryToFindOutcomesRelatedToEntity(entity);
  const combinedDates = [];
  correspondence.forEach(item => {
    if ( !combinedDates.includes(item.date) ) {
      combinedDates.push(item.date);
    }
  });
  outcomes.forEach(item => {
    if ( !combinedDates.includes(item.date) ) {
      combinedDates.push(item.date);
    }
  });
  combinedDates.sort();
  combinedDates.forEach(date => {
    /*combined.push({
      meta_type: "date",
      date: date
    })*/
    const correspondenceItems = correspondence.filter(item => item.date === date);
    const outcomeItems = outcomes.filter(item => item.date === date);

    if ( correspondenceItems.length > 0 ) {
      correspondenceItems.map(item => item.meta_type = "correspondence")
      //correspondenceItem.meta_type = "correspondence";
      combined.push(...correspondenceItems);
    }
    if ( outcomeItems.length > 0 ) {
      outcomeItems.map(item => item.meta_type = "outcome");
      combined.push({ meta_type: "outcomes", items: outcomeItems});
    }
  });

  const groupedOutcomesWithNoCorrespondenceInBetween = [];

  combined.forEach((item, index) => {
    const previousItem = combined[index - 1] || undefined;
    const nextItem = combined[index + 1] || undefined;
    if ( item.meta_type === "outcomes" && nextItem?.meta_type === "outcomes" ) {
      groupedOutcomesWithNoCorrespondenceInBetween.push({
        meta_type: "outcomes",
        items: [
          ...item.items,
          ...nextItem.items
        ]
      });
    }
    else if ( item.meta_type === "outcomes" && previousItem?.meta_type === "outcomes" ) {

    }
    else {
      groupedOutcomesWithNoCorrespondenceInBetween.push(item);
    }
  });

  return groupedOutcomesWithNoCorrespondenceInBetween;
}

const DiscussionThread = ({ entity }) => {
  const combinedCorrespondenceAndOutcomesByDate = combineCorrespondenceAndOutcomesByDate(entity);

  const { getEntityHash, getEntityTitle } = useDiscussion();

  return (
    <StyledDiscussionThread>
      {combinedCorrespondenceAndOutcomesByDate.map((item, index) => {
        const previousItem = combinedCorrespondenceAndOutcomesByDate[index - 1] || undefined;
        const nextItem = combinedCorrespondenceAndOutcomesByDate[index + 1] || undefined;
        return (
          <DiscussionThreadItem 
            key={index} 
            item={item} 
            previousItem={previousItem}
            nextItem={nextItem}
            id={index+1}
            permalink={getEntityHash(entity)}
          />
        )
      })}
      <div className="end">
        <span>Future correspondence will be added here as this conversation continues.</span>
      </div>
    </StyledDiscussionThread>
  );
};

export default DiscussionThread;

const DiscussionThreadItem = ({ item, previousItem, nextItem, id, permalink }) => {

  return (
    <>
      {previousItem?.date !== item?.date  && item?.meta_type !== "outcomes" && (
        <div className="date">
          <FormattedDate date={item.date} />
        </div>
      )}
      {item.meta_type === "correspondence" && (
        <StyledDiscussionThreadItemInteraction className={`is-${item.type}`}>
          <span className="bookmark" id={`correspondence-${id}`}></span>
          <div className="permalink">
            <Permalink href={`${permalink}#correspondence-${id}`} />
          </div>
          <div className="content">
            {item.method && <p>{item.method}</p>}
            {item.content && <ReactMarkdown>{item.content}</ReactMarkdown>}
          </div>
        </StyledDiscussionThreadItemInteraction>
      )}
      {item.meta_type === "outcomes" && (
        <StyledDiscussionThreadItemOutcomes className={`is-outcome ${previousItem?.meta_type !== "outcome" && "has-top-border"} ${nextItem?.meta_type !== "outcome" && "has-bottom-border"}`}>
          {nextItem && nextItem !== "outcomes" && (
            <span className="continues"><span>Correspondence Continues Below</span></span>
          )}
          <header>
            <h2>Relevant Impact</h2>
          </header>
          {item.items.map((outcome, index) => (
            <ImpactItem item={outcome} key={index} showEntities={false} showTag={false}  />
          ))}
          {nextItem && nextItem !== "outcomes" && (
            <span className="continues"><span>Correspondence Continues</span></span>
          )}
        </StyledDiscussionThreadItemOutcomes>
      )}
    </>
  );
};

const StyledDiscussionThreadItemOutcomes = styled.aside`
  padding: 2.5em 0 3em;
  margin-top: 2em;
  margin-bottom: 1em;
  border: dashed rgba(255,255,255,0.3);
  border-width: 1px 0;
  display: flex;
  flex-direction: column;
  gap: 1.5em;
  position: relative;
  @media ( min-width: 48em ) {
    padding-right: 1.5em;
    padding-left: 1.5em;
  }
  .continues {
    position: absolute;
    left: 50%;
    background-color: var(--color-black);
    &:first-of-type {
      top: 0;
      transform: translate3d(-50%,-50%,0);
      margin-top: -0.1875em;
    }
    &:last-of-type {
      bottom: 0;
      transform: translate3d(-50%, 50%,0);
      margin-bottom: 0.125em;
    }
    span {
      padding: 0 1em;
      font-size: 0.75em;
      font-weight: 500;
      opacity: 0.5;
      line-height: 1;
      white-space: nowrap;
    }
  }
  > header {
    h2 {
      font-size: 1.125em;
      font-weight: 700;
      opacity: 0.5;
      margin: 0;
      line-height: 1;
      text-align: center;
    }
  }
`;

const StyledDiscussionThreadItemInteraction = styled.div`
  position: relative;
  padding: 0.875em 1em 0.875em;
  width: 90%;
  font-feature-settings: "lnum" 1;
  .bookmark {
    position: absolute;
    display: block;
    height: calc((var(--navbar-height) + 77px) + 3em);
    margin-top: calc( (-1 * (var(--navbar-height) + 77px)) - 3em);
    visibility: hidden;
  }
  .permalink {
    position: absolute;
    top: 0.625em;
    right: 0.625em;
  }
  @media ( min-width: 48em ) {
    padding: 1.375em 1.5em 1.125em;
    width: 80%;
  }
  border-radius: 1em;
  background-color: #191919;
  &.is-reply {
    justify-self: end;
    color: var(--color-black);
    background-color: var(--color-white);
  }
  .content {
    img {
      display: block;
      margin: 1em auto;
    }
    ol,
    ul,
    p {
      margin: 0;
      &:not(:last-child) {
        margin-bottom: 1em;
      }
      font-family: var(--font-serif);
      font-size: 1.125em;
      line-height: 1.4;
      @media ( min-width: 48em ) {
        font-size: 1.25em;
        line-height: 1.5;
      }
    }
    li p {
      font-size: inherit;
    }
    a {
      text-decoration-line: underline;
      text-decoration-thickness: 0.75px;
      text-underline-offset: 0.1em;
      text-decoration-color: var(--theme-heavy-border-against-dark);
      transition: opacity 0.2s ease;
      opacity: 0.7;
    }
    .can-hover & a:hover,
    a:active {
      opacity: 0.5;
    }
  }
`;


const StyledDiscussionThread = styled.section`
  position: relative;
  margin: 0;
  padding: 2em 0 0 !important;
  display: grid;
  gap: 2em;
  padding-bottom: 1em;
  @media ( min-width: 60em ) {
  }
  
  > .date {
    text-align: center;
    font-size: 0.875em;
    font-weight: 500;
    opacity: 0.5;
    margin-bottom: -1em;
  }
  
  .end {
    text-align: center;
    padding: 3em 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5em;
    opacity: 0.5;
    font-size: 0.875em;
    @media ( min-width: 60em ) {
      padding-bottom: 6em;
    }
    span {
      font-weight: 500;
    }
  }
    
`;
